<div id="draggable-pie-chartdiv" style="width: 100%; height: 500px; border: 1px solid #ccc; background-color: #f9f9f9;"></div>
